import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Plan from "./Plan";
import c from "../etc/Const"
import {connect, useDispatch} from "react-redux";
import {fetchScenario} from "../../data/actions";
import {HTML5Backend} from "react-dnd-html5-backend";
import {DndProvider} from "react-dnd";
import SliderDragLayer from "../control/sliderDragLayer";

const Scenario = ({}) => {
    const params = useParams();
    const dispatch = useDispatch()

    useEffect(() => {
        const p = "plan" // /" + params.scid + "/module"
        //console.log("fetch %s", p)

        dispatch(fetchScenario(p))
    }, []);

    return (


            <div style={{
                overflow: 'hidden',
            }}>
                <Plan uid={params.scid}/>
            </div>

    )
}

function mapStateToProps(state, other) {
    return {plandata: state.plan.items}
}

export default connect(mapStateToProps)(Scenario)

